import { Map, List } from 'immutable';
import ResourceState from './state';
import isPending from './is-pending';
import hasErrors from './has-errors';

const DEFAULT_STATE = new Map({
  id: null,
  items: [],
  total: 0,
});

export default (Schema, EntitySchema, selectEntities, selectResource) => {
  const entityType = EntitySchema.name.toLowerCase();

  return (collectionType, id) => state => {
    // TODO: Leaving this here for reference. Should we convert to
    //       this way of doing things or simply remove the concept
    //       of 'selectEntities'.
    // const selectItems = createItemSelector(selectEntities, selectResource);
    // const selected = selectItems(state, entityType, id);

    const existing = state[collectionType].get(id) || DEFAULT_STATE;
    const selected = [];

    existing.get('items').forEach(entityId => {
      const entity = state[entityType].get(entityId);
      if (entity) {
        selected.push(selectResource(entityType, entity.id)(state));
      }
    });

    return new ResourceState({
      data: new Schema({
        id,
        total: existing.get('total'),
        items: new List(selected),
      }),
      pending: isPending(collectionType, id, state),
      error: hasErrors(collectionType, id, state),
    });
  };
};
